<template>
  <div>
     <div class="container">
        <p class="title">在线报名</p>
        <p class="little_title">{{terantInfo.brandName}}代驾司机招募</p>
        <div class="auth_code">
            <input placeholder="请输入手机号" v-model="phone" />
            <input placeholder="请输入验证码" v-model="code" @input="watchVal($event)"/>
            <button :disabled="disabled" @click="sendCode">{{btnTxt}}</button>
        </div>
        <p class="status" v-show="disabled">验证码已发送，可能会有延后，请耐心等待</p>
    </div>
 <button class="submit" @click="submit">注册/登录</button>
      <div class="agreement" v-if="proList.length>0">
        <img :src="isAgree?icon_yes:icon_no" @click="changeAgree"/>
        <span>我已阅读并同意</span>
        <a href="javascript:void(0);" @click="protocolUrlAction" :data-channel="proList[0].channel">{{proList[0].name}}</a>
        <span v-if="proList[1]">&</span>
        <a href="javascript:void(0);" @click="protocolUrlAction" :data-channel="proList[1].channel" v-if="proList[1]">{{proList[1].name}}</a>
      </div>
     <div class="notes">
            <p>报名须知</p>
            <ul>
                <li>报名信息必须真实有效，且满足平台规定安全驾驶无事故；</li>
                <li>报名人员应满足平台规定的年龄限制，且身体健康；</li>
                <li>确认自愿使用平台信息服务；</li>
                <li>确认有以下证件：身份证、驾驶证；</li>
                <li>根据城市不同，确认同意在成功签约后从信息费账户扣缴报名注册费；</li>
            </ul>
        </div>
  </div>
</template>

<script>
// 协议对象
const NOTICETYPE = {
    CLIENT: 1, //用户
    DRIVER: 2 //司机
}

// 协议类型
const CHANNEL = {
    PRIVACY: 1, //隐私协议
    SERVICE: 2, //服务协议
}

import {showToast, changeHistory, isAlipay} from '../../utils/common.js'
import {createVerifycode, checkVerifycode, checkStatus,agreementCheck,agreementAgree} from '../../utils/actions'
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      drivingAgreement: location.origin + '/driver-app-pack/driver-study/page/10/10_1.html',
      msgAgreement: location.origin + '/driver-app-pack/driver-study/page/10/10_2.html',
      phone: '',
      code: '',
      btnTxt: '获取验证码',
      time: 0,
      disabled: false,
      icon_yes: require('../../assets/choose_yes.png'),
      icon_no: require('../../assets/choose_no.png'),
      isAgree: true,
      proList: [],
      protocolUrl: "../../../../user-app-pack/user-protocol/protocol.html?type=2&channel="
    }
  },
  created () {
    if (!isAlipay) {
      changeHistory();
    }
    this.getProtocolList();
  },
  computed: {
    ...mapGetters({
      terantInfo:'getTerantInfo'
    })
  },

  methods: {
    watchVal (e) {
      let val = e.target.value
      this.code = val.substring(0, 6)
    },
    sendCode () {
      if (!this.checkCode()) return
      this.createVerifycode()
    },

    checkCode () {
      let reg = 11 && /^1\d{10}$/
      if (this.phone == '') {//eslint-disable-line
        showToast('请输入手机号码')
      } else if (!reg.test(this.phone)) {
        showToast('手机格式不正确')
      } else {
        return this.phone
      }
    },

    async createVerifycode () {
      let _this = this
      let data = await createVerifycode({
        mobile: _this.phone,
        business: 'driverSignup'
      })
      if(data&&data.code == 0){//eslint-disable-line
        _this.disabled = true
        _this.time = 60
        _this.timer()
      }
    },

    timer () {
      if (this.time > 0) {
        this.time--
        this.btnTxt = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.disabled = false
        this.time = 0
        this.btnTxt = '获取验证码'
      }
    },

    changeAgree () {
      this.isAgree = !this.isAgree
    },

    protocolUrlAction(e){
      console.log(e)
      let channel = e.target.dataset.channel
      let token = localStorage.getItem("token");
      location.href = this.protocolUrl+channel;
    },

    async getProtocolList (){
      function getName(param) {
        let txt = '';
        if (param.channel == CHANNEL.PRIVACY){
          txt = '隐私政策';
        }else if (param.channel == CHANNEL.SERVICE) {
          txt = '服务协议'
        }
        return txt;
      }
      let res =  await agreementCheck({
        type: 2,//司机端是2，用户端是1
      });
      console.log(res)
      if (res.code*1 != 0) {
        showToast(res.message);
        return;
      }
      let list = [];
      if (res.data && res.data[0]){
        res.data.forEach(item => {
          item.name = getName(item)
          list.push(item);
        });
      }
      this.proList = list;
    },

    submit () {
      if (!this.isAgree && this.proList.length > 0) {
        let txt = '';
        if (this.proList[0]){
          txt += this.proList[0].name
        }
        if(this.proList[1]){
          txt+='&'+this.proList[1].name
        }
        showToast('请您阅读并同意'+txt)
        return
      }
      if (!this.checkCode()) return
      if (!this.code || this.code.length > 6) {
        showToast('请输入正确验证码')
        return
      }
      this.checkVerifycode()
    },

    async checkVerifycode () {
      let _this = this
      let data = await checkVerifycode({
        mobile: _this.phone,
        verifyCode: _this.code,
        business: 'driverSignup',
        agree: '1'// 同意代驾服务协议
      })
      if (data) {
        localStorage.setItem("token",data.data.token)
        this.sendAgreement(data.data.token);
        this.checkStatus(data.data.token);
      }
    },
    sendAgreement(token){
      let _this = this;
      this.proList.forEach(item=>{
        agreementAgree({
          type: 2,
          token: token,
          id: item.id,
          _userId: _this.phone
        }).then(res=>{
          console.log(res)
        })
      })
    },
    async checkStatus (token) {
      let data = await checkStatus({token })
      if (!data) return
      this.$store.commit('USER_INFO', {...data.data,token:token});
      if (data.data.recycle == '1') {//eslint-disable-line
        this.$router.push({name: 'defeat'})
        return
      }
      switch (data.data.status) { // 待完善
        case '1': // 流程第1步报名
          // 报名页面1
          this.$router.push({name: 'signUp', params: {status: data.data.status}})
          break
        case '2': // 报名成功,
        case '3': // 考试未通过
        case '4': // 考试通过
          // 答题页 2
          this.$router.push({name: 'recruitAnswer', params: {status: data.data.status}})
          break
        case '5': // 身份证证件未通过
          // 身份证拍照页面
          this.$router.push({name: 'cardIDUpLoad', params: {status: data.data.status}})
          break
        case '6': // 身份证证件通过
        case '7': // 驾驶证未通过
          // 驾驶证拍照页面
          this.$router.push({name: 'licenceLoad', params: {status: data.data.status}})
          break
        case '8': // 驾照验证通过
        case '9': // 面试未邀请
        case '10': // 面试已邀请
        case '11': // 面试未通过
          // 信息审核 5
          this.$router.push({name: 'msgAudit', params: {status: data.data.status}})
          break
        case '12': // 面试通过
        case '13': // 路考未预约
          // 预约路考页面 6
          this.$router.push({name: 'appointedRoadTest', params: {status: data.data.status}})
          break
        case '14': // 路考已预约-报名完成
        case '15': // 路考进行中
        case '16': // 路考不通过
        case '17': // 路考通过
        case '18': // 成功签约
        case '19': // 已领装备
          this.$router.push({name: 'passStatus', params: {status: data.data.status}})
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
     width: 80%;
    margin-left: 10%;
    .title{
        font-size: .4rem;
        color: #19191A;
        font-weight: bold;
        margin-top: .8rem;
    }
    .little_title{
        font-size: .24rem;
        color: #19191A;
        margin-bottom: .08rem;
    }
    input{
        width: 100%;
        border:none;
        height: .98rem;
        line-height: .98rem;
        font-size: .28rem;
        border-bottom: 1px solid #E8E9EB;
        vertical-align: bottom;
        border-radius: 0;
        background: #FCFDFF;
        padding:0
    }
    .status{
        font-size: .24rem;
        color: #19191A;
        margin: .14rem 0 .32rem 0;
        text-align: center;
    }
}
.auth_code{
    position: relative;
    button{
        font-size: .28rem;
        position: absolute;
        right: 0;
        height: .98rem;
        line-height: .98rem;
        display: inline-block;
        bottom: .02rem;
        border:none;
        padding: 0;
        background: #FCFDFF;
        outline: none;
        }
    }
.agreement{
    width: 80%;
    font-size: .24rem;
    margin: .26rem 0 .76rem 10%;
    img{
        width: .24rem;
        height: auto;
        vertical-align: middle;
        padding-bottom: .1rem;
        margin-right: .1rem;
    }
    a{
        color: #4AA8EC;
        height: .4rem;
        line-height: .4rem;
        display: inline-block;
    }
    span{
      height: .4rem;
      line-height: .4rem;
      display: inline-block;
    }
}
.notes{
   width: 82%;
    margin-left: 9%;
    font-size: .24rem;
    color: #97989B;
    margin-top: .51rem;
    p{
      font-weight: bold;
      margin-bottom: .36rem;
    }
    ul{
        list-style-type: decimal;
        margin-left: .35rem;
        line-height: .36rem;
    }
}
.submit{
        margin-left: 7%;
        width: 86%;
        margin-top: .8rem;
        background-image: linear-gradient(269deg, #F25050 0%, #C93131 100%);
        border-radius: .04rem;
        color: #fff;
        height: .92rem;
        line-height: .92rem;
        font-size: .3rem;
        padding: 0;
        border:none;
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue